function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#D80027"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67215 6.53699L8.32856 7.44152L9.39159 7.09683L8.73415 8.00058L9.39046 8.90508L8.3278 8.55908L7.6704 9.46283L7.67109 8.3453L6.6084 7.9993L7.67146 7.65461L7.67215 6.53699Z",
  fill: "#F0F0F0"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.88067 10.2608C4.63205 10.2608 3.6198 9.24854 3.6198 7.99991C3.6198 6.75129 4.63205 5.73904 5.88067 5.73904C6.26998 5.73904 6.6363 5.8375 6.95611 6.01079C6.45439 5.5201 5.76823 5.21729 5.01111 5.21729C3.4743 5.21729 2.22852 6.4631 2.22852 7.99988C2.22852 9.53666 3.47433 10.7825 5.01111 10.7825C5.7683 10.7825 6.45442 10.4796 6.95611 9.98897C6.6363 10.1623 6.26998 10.2608 5.88067 10.2608Z",
  fill: "#F0F0F0"
});
const SvgTurkey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTurkey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/turkey.1b37b9c2.svg";
export { ForwardRef as ReactComponent };